import { render } from "./ConfigurarCortes.vue?vue&type=template&id=f0842cc2"
import script from "./ConfigurarCortes.vue?vue&type=script&lang=js"
export * from "./ConfigurarCortes.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__